(function () {
  var busy = false;
  var queue = [];

  function runNext() {
    if (queue.length === 0) {
      busy = false;
      return;
    }
    var job = queue.shift();
    job();
  }

  function unlockSoon() {
    /* Small delay so the DOM settles before the next queued op fires */
    setTimeout(runNext, 300);
  }

  /* Intercept ALL fetch calls to cart endpoints.
     While an op is in flight, later cart ops are QUEUED (not rejected)
     and executed in order once the current one settles. */
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var self = this;
    var url = args[0];
    if (url && typeof url !== 'string') url = url.url || '';
    var isCartOp = typeof url === 'string' && (
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1 ||
      url.indexOf('/cart/clear') !== -1
    );

    if (!isCartOp) return origFetch.apply(this, args);

    function exec() {
      return origFetch.apply(self, args)
        .then(function (response) { unlockSoon(); return response; })
        .catch(function (err) { unlockSoon(); throw err; });
    }

    if (busy) {
      return new Promise(function (resolve, reject) {
        queue.push(function () {
          exec().then(resolve, reject);
        });
      });
    }

    busy = true;
    return exec();
  };

  /* Block rapid clicks on cart buttons (duplicate-click protection stays) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.upsell-add-button, .quantity__button, .cart-item__remove, [data-cart-remove]');
    if (!btn) return;
    if (busy) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);

  /* Block rapid form submits */
  document.addEventListener('submit', function (e) {
    if (!e.target.action || e.target.action.indexOf('/cart/add') === -1) return;
    if (busy) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);
})();